import { get } from 'lodash';
import request from 'utils/request';
import paramsBuilder from 'utils/paramsBuilder';
import getViewCheckpointId from 'utils/getViewCheckpointId';
import { SURVEY_EXTENDED_FORMAT } from './constants';

export function fetchSurvey(params, options) {
  const requestOptions = {
    ...options,
    method: 'GET',
  };

  const urlParams = paramsBuilder({
    checkpointId: getViewCheckpointId(),
  });

  return request(`/api/v3/survey/${params.id}${urlParams}`, requestOptions);
}

export function fetchExtendedSurvey(params, options) {
  const requestOptions = {
    ...options,
    method: 'GET',
  };
  const { id, stripAnswerHtml } = params;
  const urlParams = paramsBuilder({
    id,
    format: SURVEY_EXTENDED_FORMAT,
    stripAnswerHtml,
    checkpointId: getViewCheckpointId(),
  });

  return request(`/api/v1/survey${urlParams}`, requestOptions);
}

export function updateSurvey(params, options) {
  const { id, ...bodyParams } = params;
  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyParams),
  };
  return request(`/api/v3/survey/${id}`, requestOptions);
}

export function updateIR(params, options) {
  const { surveyId, value } = params;
  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ irEstimation: value }),
  };
  return request(`/api/v3/survey/${surveyId}/ir`, requestOptions);
}

export function deleteIR(params, options) {
  const { surveyId } = params;
  const requestOptions = {
    ...options,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
    },
  };
  return request(`/api/v3/survey/${surveyId}/ir`, requestOptions);
}

export function renameSurvey({ id, name }, options) {
  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name }),
  };
  return request(`/api/v3/survey/${id}/name`, requestOptions);
}

export function renameSurveyPeeq({ id, name }, options) {
  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name }),
  };
  return request(`/api/v3/survey/peeq/${id}/name`, requestOptions);
}

export function updateSurveyTerms(
  { surveyId, isEnabled, title, body, surveyName: name },
  options,
) {
  const bodyPayload =
    isEnabled || title || body
      ? { terms: { isEnabled, title, body }, name }
      : { name };

  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyPayload),
  };
  return request(`/api/v3/survey/${surveyId}/name-terms`, requestOptions);
}

export function storePeeqTargeting(params, options) {
  const { surveyId, targetingData } = params;

  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(targetingData),
  };

  return request(`/api/v3/survey/peeq/${surveyId}/audiences`, requestOptions);
}

export function storeSurvey(
  { surveyId, isThirdParty, isDistributionLink, isPeeq, ...data },
  options,
) {
  let payload = data;
  const isRevision = get(data, 'targeting.isRevision', false);

  if (!isDistributionLink && !isPeeq) {
    const targetingData = get(data, 'targeting');
    if (isThirdParty || isRevision) {
      payload = targetingData;
    }
  }

  let endpoint = `/api/v3/survey-draft/${surveyId}/upsert`;
  if (isThirdParty) {
    endpoint = `/api/v3/survey-draft/${surveyId}/targeting`;
  }
  if (isRevision) {
    endpoint = `/api/v3/survey/${surveyId}/targeting/revision`;
  }
  if (isDistributionLink) {
    endpoint = `/api/v3/distribution-link/${surveyId}/upsert`;
  }
  if (isPeeq) {
    endpoint = `/api/v3/survey/peeq/${surveyId}/upsert`;
    // remove targeting from payload for peeq surveys
    // now that we have a separate endpoint for targeting
    delete payload.targeting;
  }

  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  return request(endpoint, requestOptions);
}
